<template lang="pug">
.badges-badge(
  v-tooltip="tooltipOptions"
  data-tipclass="badge-tooltip"
  :title="title"
  @mouseover="$emit('mouseover-badge')"
)
  img(
    :class="badgeClasses"
    :src="badge.src"
    :alt="title"
  )
  .badge-streak(
    v-if="label"
    :class="streakClasses"
  )
    | {{ label }}
</template>

<script>
import { ACHIEVEMENT_BADGES } from '~/app_constants';

export default {
  name: 'AppAchievementBadge',
  props: {
    achievement: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium'].includes(value),
    },
    max: {
      type: Number,
      default: 999,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({
      html: true,
      placement: 'bottom',
    }),
  }),
  computed: {
    badge() {
      return ACHIEVEMENT_BADGES[this.achievement.category];
    },
    title() {
      return this.achievement.title || this.badge.alt;
    },
    label() {
      const count = this.achievement.count;

      if (!count) {
        return '';
      }

      return count > this.max ? `${this.max}+` : count;
    },
    badgeClasses() {
      return `badge-icon badge-icon-${this.size}`;
    },
    streakClasses() {
      return `badge-streak-${this.size}`;
    },
  },
};
</script>
